import { render, staticRenderFns } from "./PagesIcon.vue?vue&type=template&id=46c39de8&"
import script from "./PagesIcon.vue?vue&type=script&lang=js&"
export * from "./PagesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports